export const environment = {
    production: false,
    apiUrl: 'https://checkmate-dev.transnetyx.com/api',

    auth0: {
        domain: 'login-dev.transnetyx.com',
        clientId: 'ISLvbmOINGmK44Ma6UWetejoKyRzekd5',
        redirectUri: `${window.location.origin}`,
        logoutReturnUrl: `https://accounts-dev.transnetyx.com/v2/logout/quick-order`,
        logoutUrl: 'https://login-dev.transnetyx.com/v2/logout',
    },

    analytics: {
        enable: true,
        mixpanelCode: '591f4ee37b495061500bf92a67822ccb',
    },

    colonyUrl: 'https://colony-dev.transnetyx.com/',
    automatedGenotypingUrl: 'https://quickorder-dev.transnetyx.com/Default.aspx',
    geneticMonitoringUrl: 'https://quickorder-dev.transnetyx.com/GeneticMonitoring/home',
    microbiomeUrl: 'https://quickorder-dev.transnetyx.com/MVC/Microbiome/home',
    quickorderUrl: 'https://quickorder-dev.transnetyx.com/MVC/Account/Register',
    ordersUrl: 'https://quickorder-dev.transnetyx.com/Orders.aspx',
    newOrdersUrl: 'https://quickorder-dev.transnetyx.com/Order1.StrainSelection.aspx',
    geneticMonitoringOrdersUrl: 'https://quickorder-dev.transnetyx.com/MVC/GeneticMonitoring/Orders',
    microbiomeOrdersUrl: 'https://quickorder-dev.transnetyx.com/MVC/Microbiome',
    accountSettingsUrl: 'https://accounts-dev.transnetyx.com/Account/Details',
    accountRegisterUrl:
        'https://accounts-dev.transnetyx.com/register/quick-order?redirectUri=https:%2F%2Fcheckmate-dev.transnetyx.com',
    quickorderSettingsUrl: 'https://quickorder-dev.transnetyx.com/Account.aspx',
    billingSettingsUrl: 'https://quickorder-dev.transnetyx.com/OrderSearch.aspx',
    messageSettingsUrl: 'https://quickorder-dev.transnetyx.com/EmailPreferences.aspx',
    quickorderDashboardUrl: 'https://quickorder-dev.transnetyx.com',
    orderSearchUrl: 'https://quickorder-dev.transnetyx.com/OrderSearch.aspx',
    quickorderStrainsUrl: 'https://quickorder-dev.transnetyx.com/StrainManage.aspx',
    quickorderCreateStrainUrl: 'https://quickorder-dev.transnetyx.com/StrainAdd.aspx',
    quickorderSequencingRequestsUrl: 'https://quickorder-dev.transnetyx.com/SequencingRequests.aspx',
    quickorderCentralShippingUrl: 'https://quickorder-dev.transnetyx.com/CentralShipping/Default.aspx',
    quickorderMySuppliesUrl: 'https://quickorder-dev.transnetyx.com/SupplyRequest.aspx',
    quickorderRetestSuppliesUrl: 'https://quickorder-dev.transnetyx.com/SupplyRequest.aspx',
    quickorderResultsUrl: 'https://quickorder-dev.transnetyx.com/OrderResults.aspx',
    quickorderStrainUrl: 'https://quickorder-dev.transnetyx.com/Strain.aspx',
    quickorderMessagesUrl: 'https://quickorder-dev.transnetyx.com/Messages.aspx',
    supportHubUrl: 'https://www-dev.transnetyx.com/support',
};
